import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { VERSION } from "@core/version";
import { CacheId } from "@shared/enums";
import { catchError, map, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class KnownIssuesService {
  http = inject(HttpClient);
  appVersion = VERSION;

  getKnownIssues(): Observable<any> {
    const storedIssues = localStorage.getItem(CacheId.KnownIssues);

    if (storedIssues) {
      const parsedIssues = JSON.parse(storedIssues);

      if (parsedIssues.appVersion === this.appVersion) {
        return of(parsedIssues.issues);
      } else {
        localStorage.removeItem(CacheId.KnownIssues);
      }
    }

    return this.createAndStoreIssues();
  }

  private createAndStoreIssues(): Observable<any> {
    return this.http.get("./assets/data/known-issues.json").pipe(
      map((data) => {
        const newIssues = {
          appVersion: this.appVersion,
          issues: (data as any[]).reverse(),
        };
        localStorage.setItem(CacheId.KnownIssues, JSON.stringify(newIssues));
        return newIssues.issues;
      }),
      catchError((error) => {
        console.error("Failed to load known issues", error);
        return of([]);
      })
    );
  }
}
